import React, { ReactNode } from "react";
import { ConfigProvider, theme } from "antd";
import { colors } from "../devdata/constants/themes";

interface ThemeProviderProps {
  children: ReactNode;
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgContainer: colors.darkMode.layer2,
          fontFamily:
            "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
          colorBorder: colors.darkMode.layer2,
          colorBgElevated: colors.darkMode.layer3,
          colorText: colors.darkMode.text,
          colorTextPlaceholder: colors.darkMode.subText,
          controlItemBgHover: colors.darkMode.layer1,
          controlOutline: "none",
          borderRadius: 8,
          controlHeight: 36,
        },
        algorithm: theme.darkAlgorithm,
        components: {
          Table: {
            headerBg: colors.darkMode.layer2,
            headerColor: colors.darkMode.text,
            colorText: colors.darkMode.text,
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
            bodyFontSize: 14,
            headerFontSize: 14,
          },
          Select: {
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
            optionSelectedBg: colors.darkMode.layer3,
            optionActiveBg: colors.darkMode.layer1,
            colorBgContainer: colors.darkMode.layer2,
            colorBgElevated: colors.darkMode.layer3,
            colorText: colors.darkMode.text,
            colorTextPlaceholder: colors.darkMode.subText,
            borderRadius: 8,
            controlHeight: 36,
            optionSelectedColor: colors.darkMode.green,
            colorBorder: colors.darkMode.layer2,
            colorPrimary: colors.darkMode.green,
            selectorBg: colors.darkMode.layer2,
            multipleItemBg: colors.darkMode.layer2,
            colorTextDisabled: colors.darkMode.subText,
            colorBgContainerDisabled: colors.darkMode.layer3,
            dropdownClassName: "custom-select-dropdown text-darkMode-text",
            colorBorderSecondary: colors.darkMode.layer2,
            hoverBorderColor: colors.darkMode.green,
            activeBorderColor: colors.darkMode.green,
            colorPrimaryHover: colors.darkMode.green,
            colorPrimaryActive: colors.darkMode.green,
          },
          Input: {
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
            colorBgContainer: colors.darkMode.layer2,
            colorBorder: colors.darkMode.layer2,
            colorText: colors.darkMode.text,
            colorTextPlaceholder: colors.darkMode.subText,
          },
          Button: {
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
          },
          Tag: {
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
          },
          Switch: {
            // colorPrimary: colors.darkMode.greenDarker,
            // handleBg: colors.darkMode.text,
            // colorTextQuaternary: colors.darkMode.text,
            // colorBgContainer: colors.darkMode.layer2,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export { ThemeProvider };
export default ThemeProvider;
